import React from 'react';

export default function PayslipTable({
  records = [],
  isLoading = false,
  onResetFilters,
  onOpenSlipModal,
}) {
  if (isLoading) {
    return (
      <div className="flex h-64 w-full items-center justify-center rounded-2xl border border-outline-variant/20 bg-surface-container-lowest">
        <div className="flex flex-col items-center gap-2">
          <div className="h-8 w-8 animate-spin rounded-full border-3 border-primary border-t-transparent" />
          <span className="text-xs font-semibold text-on-surface-variant">Loading pay slip records...</span>
        </div>
      </div>
    );
  }

  if (records.length === 0) {
    return (
      <div className="flex h-64 w-full flex-col items-center justify-center rounded-2xl border border-outline-variant/20 bg-surface-container-lowest p-8 text-center">
        <span className="material-symbols-outlined mb-2 text-4xl text-outline-variant">
          receipt_long
        </span>
        <h3 className="font-display text-sm font-bold text-black">No Pay Slip Entries Found</h3>
        <p className="mt-1 text-xs text-slate-600 max-w-sm">
          No pay slip components found for the selected month, year, or filter criteria.
        </p>
        {onResetFilters && (
          <button
            type="button"
            onClick={onResetFilters}
            className="mt-4 inline-flex items-center gap-1.5 rounded-xl bg-primary/10 px-3.5 py-1.5 text-xs font-bold text-primary hover:bg-primary/20 transition cursor-pointer"
          >
            <span className="material-symbols-outlined text-sm">refresh</span>
            <span>Reset Filters</span>
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-xl border border-outline-variant/25 bg-surface-container-lowest shadow-xs">
      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm border-collapse">
          <thead>
            <tr className="border-b border-outline-variant/25 bg-surface-container-low/40 text-[11px] font-extrabold uppercase tracking-wider text-black">
              <th className="py-3.5 px-6 text-black">MONTH</th>
              <th className="py-3.5 px-6 text-black">PAY HEAD</th>
              <th className="py-3.5 px-6 text-center text-black">DR / CR</th>
              <th className="py-3.5 px-6 text-right text-black">AMOUNT</th>
              <th className="py-3.5 px-6 text-black">REMARKS</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-outline-variant/15">
            {records.map((item, index) => {
              const isCredit = item.drCr === 'Cr';
              return (
                <tr
                  key={item.id || index}
                  className="transition-colors hover:bg-surface-container-low/50 group"
                >
                  {/* MONTH */}
                  <td className="py-4 px-6 font-sans tabular-nums font-bold text-sm text-on-surface whitespace-nowrap">
                    {item.monthYear || `${item.month} ${item.year}`}
                  </td>

                  {/* PAY HEAD */}
                  <td className="py-4 px-6 whitespace-nowrap">
                    <div className="flex flex-col">
                      <span className="font-bold text-sm text-on-surface font-sans">
                        {item.payHead}
                      </span>
                      <span className="text-[11px] text-slate-500 font-medium">
                        {item.payHeadType}
                      </span>
                    </div>
                  </td>

                  {/* DR / CR */}
                  <td className="py-4 px-6 text-center whitespace-nowrap">
                    <span
                      className={`inline-flex items-center justify-center rounded-full px-2.5 py-0.5 text-xs font-bold font-sans ${
                        isCredit
                          ? 'bg-emerald-50 text-emerald-700 border border-emerald-200'
                          : 'bg-rose-50 text-rose-700 border border-rose-200'
                      }`}
                    >
                      {item.drCr} ({isCredit ? 'Earnings' : 'Deduction'})
                    </span>
                  </td>

                  {/* AMOUNT */}
                  <td className="py-4 px-6 text-right whitespace-nowrap font-sans tabular-nums font-bold text-sm">
                    <span className={isCredit ? 'text-emerald-700' : 'text-rose-700'}>
                      {item.formattedAmount || `₹${Number(item.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}
                    </span>
                  </td>

                  {/* REMARKS */}
                  <td className="py-4 px-6 text-xs text-slate-600 font-medium">
                    {item.remarks || '—'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
